// URL API
let urlApi = '';
let urlApi2 = '';
let urlApi3 = '';
let urlApi4 = '';
let urilApiV2 = '';
let urlApiIntegration = '';

// CONSTANT FROM DEV
let isDebug = false;

// CHECK HOST
if (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "marqponto-master-dev.azurewebsites.net") {
  console.log("Local");
  urlApi = "https://api-v1.marqhr-dev.com.br/";
  urlApi2 = "https://report.marqhr-dev.com.br/api/";
  urlApi3 = "https://core.marqhr-dev.com.br/api/";
  urlApi4 = "https://marqflex-api-dev.azurewebsites.net/";
  urilApiV2 = "https://api-v2.marqhr-dev.com.br/";
  // MarQ.Integration.API doesn't have a dev/homolog host yet — pointing at prod until one exists.
  urlApiIntegration = "https://integracao.marqponto.com.br/";

  // urlApi = "http://localhost:2512/"

  isDebug = true;
} else if (location.hostname.includes("homolog")) {
  urlApi = "https://api-v1.marqhr-homolog.com.br/";
  urlApi2 = "https://report.marqhr-homolog.com.br/api/";
  urlApi3 = "https://core.marqhr-homolog.com.br/api/";
  urilApiV2 = "https://api-v2.marqhr-homolog.com.br/";
  // MarQ.Integration.API doesn't have a dev/homolog host yet — pointing at prod until one exists.
  urlApiIntegration = "https://integracao.marqponto.com.br/";
} else {
  urlApi = "https://api.marqponto.com.br/";
  urlApi2 = "https://report.marqponto.com.br/api/";
  urlApi3 = "https://core.marqponto.com.br/api/";
  urlApi4 = "https://marqflex-api.azurewebsites.net/";
  urilApiV2 = "https://api.marqhr.com.br/"
  urlApiIntegration = "https://integracao.marqponto.com.br/";
  isDebug = false
}
// CORE
export const CORE_PERSON_GROUP = urlApi3 + 'face/createPersonGroup';

// REPORT

export const HEALTH_SCORE = urlApi2 + 'pipe/GetHealthScore';
export const GET_ONBOARDINGS = urlApi2 + 'pipe/onboardings';
export const GET_RATING_ONBOARDINGS = urlApi2 + 'pipe/onboardingRatings';
export const GET_HEALTH_SCORE_COMPANY = urlApi2 + 'pipe/GetHealthScoreByCompanyId';
export const GET_COMPANY_DAILY_METRICS = urlApi2 + 'pipe/GetCompanyDailyMetrics';
export const GET_POINT_LOG = urlApi2 + 'audit/getPointTempLog';
export const GET_TOTAL_POINT = urlApi2 + 'report/getTotalPoint';
export const GET_LIST_FUNNEL = urlApi2 + "pipe/GetPipelineStageandBusiness";
export const GET_PROFILES_CLIENT = urlApi2 + "pipe/GetProfilesClient";
export const CHANGE_ITEM_FUNNEL = urlApi2 + "pipe/changesBusinessStage";
export const GET_DATA_COMPANY_FUNNEL = urlApi2 + "pipe/GetPipelineBusiness";
export const UPDATE_FIXED_NOTE = urlApi2 + "pipe/updateFixed";
export const GET_DEFAULT_TAGS_FUNNEL = urlApi2 + "pipe/GetDefaultTags";
export const GET_SELECT_RESPONSIBLES = urlApi2 + "pipe/GetOwners";
export const CHANGE_BUSINESS_CONTACT = urlApi2 + "pipe/updateBusinessContact";
export const GET_DATA_COMPANY_NOTF = urlApi2 + "pipe/CompanyNotifications";
export const GET_CHANGE_OWNER_FUNNEL = urlApi2 + "pipe/changeOwner";
export const CREATE_NOTE_FUNNEL = urlApi2 + "pipe/createNote";
export const CREATE_ACTIVE_FUNNEL = urlApi2 + "pipe/createActivity";
export const LASTS_ACTIVES_FUNNEL = urlApi2 + "pipe/getPipelineLast50Actions";
export const DELETE_NOTE = urlApi2 + "pipe/deleteNote";
export const REMOVE_TAG = urlApi2 + "pipe/removeTag";
export const CREATE_TAG = urlApi2 + "pipe/createTag";
export const CREATE_ONBOARDING = urlApi2 + 'pipe/createOnboarding';
export const REMOVE_ACTIVE_USER = urlApi2 + "pipe/removebusinessTask";
export const CREATE_ACTIVE_USER = urlApi2 + "pipe/createBusinessTask";
export const GET_DATA_TO_FUNIL = urlApi2 + "pipe/GetPipelineBusinessByCompanyId?companyId=";
export const POST_REPORT_FUNIL = urlApi2 + "pipe/sendManyMsgPipe";
export const CREATE_TAG_FUNNEL = urlApi2 + "pipe/RegisterTagDefault";
export const CHANGE_TICKETS_NUMBERS = urlApi2 + "ticket/DashboardNumbers?ticketProjectId=1&";
export const CHANGE_TICKETS_FILTERS = urlApi2 + "ticket/DashboardFilters?ticketProjectId=1&";
export const CHANGE_TICKETS_TICKETS = urlApi2 + "ticket/DashboardTickets?ticketProjectId=1";
export const UPDATE_TAGS_TICKTS = urlApi2 + "ticket/UpdateTicketTagList";
export const CREATE_TICKET = urlApi2 + "ticket/CreateTicket";
export const VIEW_TICKETS = urlApi2 + "ticket/";
export const UPDATE_TICKETS = urlApi2 + "ticket/UpdateTicket";
export const UPDATE_TICKETS_BULK = urlApi2 + "ticket/UpdateTicketBulk";
export const SEARCH_EMPLY = urlApi2 + "ticket/SearchCompany";
export const CREATE_ANNOTATION_TICKETS = urlApi2 + "ticket/CreateTicketTicketAnnotation";
export const UPDATE_FILE_ATTACHMENTS = urlApi2 + "ticket/UpdateTicketAttachments";
export const GET_BUSINESS_TASK_TYPES = urlApi2 + "pipe/businessTaskTypes";
export const UPDATE_BUSINESS_TASK_STATUS = urlApi2 + "pipe/updateBusinessTaskStatus";
export const GET_REPORT_POINTS = urlApi + "v1/support/report-daywork-quantity";

export const GET_AUTHENTICATION = urlApi2 + "User/GetUserAuthByDocument";
export const UPDATE_USER_ACTIVE = urlApi2 + "User/UpdateUserActiveStatus";
export const UPDATE_USER_DELETED = urlApi2 + "User/UpdateUserDeletedStatus";
export const UPDATE_LOGIN_ACTIVE = urlApi2 + "User/UpdateAuthActiveStatus";
export const UPDATE_LOGIN_DELETED = urlApi2 + "User/UpdateAuthDeletedStatus";
export const CREATE_USER_LOGIN = urlApi2 + "User/CreateUserAuth";

// URL CONSTANT
export const IS_DEBUG = isDebug;
export const UPDATE_FILES_TICKETS = urlApi + "api/v2/info/ticket/uploadImage/";
export const GET_UNIT_MASTER = urlApi + "api/v1/info/GetBusinessUnitMaster";
export const GET_CONTEXT = urlApi + "api/v1/mamlabs/GetElementContext";

// Avisos e Campanhas (Broadcast).
//
// urilApiV2 (api-v2), NAO urlApi (api-v1 legado): a feature vive no stack .NET 8
// em MarQ/src/srcs/broadcasts, servida por MarQ.Api. Apontar para o legado da 404.
//
// Prefixo "v1/", sem "api/": e a convencao do stack moderno — 60 controllers
// usam Route("v1/..."), so 3 outliers usam "api/v1/".
//
// Sem ?context=: sao rotas cross-shard, o proprio backend faz o fan-out.
//
// ===================== APONTANDO PARA LOCALHOST =====================
// Trocar para `urilApiV2` para voltar ao ambiente resolvido pelo host
// (api-v2 dev/homolog/prod). Esta e a UNICA linha a mexer.
// Porta 5156 = profile "http" do launchSettings.json de MarQ.Api.
// const broadcastApi = "http://localhost:5156/";
const broadcastApi = urilApiV2;
// ====================================================================
export const BROADCASTS = broadcastApi + "v1/mamlabs/broadcasts";
export const BROADCAST_BY_ID = (id) => broadcastApi + "v1/mamlabs/broadcasts/" + id;
export const BROADCAST_CANCEL = (id) => broadcastApi + "v1/mamlabs/broadcasts/" + id + "/cancel";
export const BROADCAST_SYNC = (id) => broadcastApi + "v1/mamlabs/broadcasts/" + id + "/sync";
export const BROADCAST_STATUS = (id) => broadcastApi + "v1/mamlabs/broadcasts/" + id + "/status";
export const BROADCAST_ENGAGEMENT = (id) => broadcastApi + "v1/mamlabs/broadcasts/" + id + "/engagement";
export const BROADCAST_ENGAGEMENT_EXPORT = (id) => broadcastApi + "v1/mamlabs/broadcasts/" + id + "/engagement/export";
// O banco vai na query string e e OBRIGATORIO: id de empresa colide entre
// bancos, e sem ele a rota responderia com a empresa homonima de outro banco.
export const BROADCAST_ENGAGEMENT_COMPANY = (id, companyId, shardId) =>
  broadcastApi + "v1/mamlabs/broadcasts/" + id + "/engagement/companies/" +
  encodeURIComponent(companyId) + "?shard=" + encodeURIComponent(shardId);
// Resolve empresas a partir de: lista colada, planilha, filtro avancado ou selecao na tabela.
export const BROADCAST_RESOLVE_COMPANIES = broadcastApi + "v1/mamlabs/broadcasts/resolve-companies";
// Troca do cross token (login legado) pelo JWT da API v2. Vai no api-v2 do
// HOST (urilApiV2), nao em broadcastApi: o cross token existe no banco de auth
// do ambiente onde o login foi feito. Ver broadcastApiV2Auth.js.
export const BROADCAST_SECURITY_CROSS = urilApiV2 + "security/cross/";

// Liberacao temporaria de funcionalidade. Mesma base (broadcastApi) e mesma
// autenticacao (requestApiV2) das campanhas: e o mesmo stack .NET 8 e a mesma
// aba do Master. A selecao de empresas reaproveita BROADCAST_RESOLVE_COMPANIES
// acima, para a regra de casamento existir num lugar so.
export const FEATURE_WINDOWS = broadcastApi + "v1/mamlabs/feature-windows";
export const FEATURE_WINDOW_OPTIONS = broadcastApi + "v1/mamlabs/feature-windows/features";
export const FEATURE_WINDOW_BY_ID = (id) => broadcastApi + "v1/mamlabs/feature-windows/" + id;
export const FEATURE_WINDOW_CANCEL = (id) => broadcastApi + "v1/mamlabs/feature-windows/" + id + "/cancel";
export const FEATURE_WINDOW_RUN = (id) => broadcastApi + "v1/mamlabs/feature-windows/" + id + "/run";
export const SEARCH_BY_INVOICE = urlApi + "api/v1/subscription/FindByBankSlip";
export const CHANGE_DADE_FEATURE = urlApi + "api/v1/feature/master/all";
export const REPORT_UPD = urlApi + 'api/v1/mamlabs/ReportUpdProblem';
export const CREATE_COMPANY_REGISTER = urlApi + "api/v1/company/Soft"
export const CHANGE_DADE_FINANCIAL = urlApi + "api/v1/info/GetFinancialBusinessInfoByCompnyId";
export const CHANGE_FINANCIAL = urlApi + "api/v1/info/updateFinancialBusinessUnit";
export const COMPANY_CHANCE_DADE_INFO = urlApi + "api/v1/payment/mam/GetPaymentInfo";
export const UPDATE_COMPANY_PROFILE = urlApi + "api/v1/subscription/UpdateCompanyTier";
export const WS_IMPORT = urlApi + "api/v1/mamlabs/enable-workshift-import";
export const GET_STORED_LOG = urlApi + 'api/v1/info/GetPointLogReport';
export const SEND_EMAIL_ONBOARDING = urlApi + 'api/v1/mamlabs/SendEmailOnboarding';
export const USER_IMPORT = urlApi + "api/v1/mamlabs/enable-user-import";
export const COMPANY_EMPLOYEE_COUNT_REPORT = urlApi + "api/v1/mamlabs/company-employee-count-report";
export const COMPANY_SHOW_BALANCE = urlApi + "api/v1/mamlabs/setIsBalanceEnabled";
export const GET_COMPANY_PIN = urlApi + "api/v1/mamlabs/getCompanyPins";
export const GET_TAB_EMPLOYEES = urlApi + "api/v1/company/tab/GetEmployees";
export const FIX_BALANCE = urlApi + 'api/v1/mamlabs/fix-balances';
export const SEARCH_SUPPORT = urlApi + 'api/v1/mamlabs/GetCompanyByIdSuportOrId?c=';
export const CHANGE_USER_CODE = urlApi + 'api/v1/mamlabs/updateUserCode';
export const CHANGE_CAMERA_NUMBER = urlApi + 'api/v1/user/updateCameraNumber';
export const CHANGE_COMPANY_INFO_CODE = urlApi + 'api/v1/mamlabs/update/company-info';
export const ADD_CHURN = urlApi + 'api/v1/mamlabs/AddToChurn';
export const ADD_INADIMPLENCIA = urlApi + 'api/v1/mamlabs/setDefault';
export const SEND_NTF_LOG = urlApi + 'api/v1/mamlabs/notifyToGetLog';
export const CHANGE_USER_WS = urlApi + 'api/v1/mamlabs/changeWorkShift';
export const LOGIN = urlApi + 'api/security/token';
export const USER_ACCESS = urlApi + 'api/v1/mamlabs/acess';
export const ADMIN_INFO = urlApi + 'api/v1/mamlabs/getAppAdminInfos';
export const ADMIN_NOTF = urlApi + 'api/v1/mamlabs/getAppAdminNotifications';
export const APP_ACCESS = urlApi + 'api/v1/mamlabs/getAppAcess';
export const ALL_COMPANY = urlApi + 'api/v1/mamlabs/getAppAdminCompaniesAll';
export const GET_MARQ_TAB = urlApi + 'api/v1/company/GetCompanyMarqTabs?companyId=';
export const GET_REPORT_CES = urlApi + 'api/v1/mamlabs/ces';
export const GET_TIMEZONE = urlApi + 'api/v1/company/GetTimeZoneList';
export const ATT_TIMEZONE = urlApi + 'api/v1/company/updateTimeZoneInfo';
export const ATT_GPS_PRECISION = urlApi + 'api/v1/company/UpdateCompanyGpsAccurate';
export const CANCEL_COMPANY_REQUEST = urlApi + 'api/v1/mamlabs/cancelrequests';
export const COMPANY_CHURN_REQUEST = urlApi + 'api/v1/mamlabs/churns';
export const REPORT_SALE = urlApi + 'api/v1/mamlabs/Sales';
export const REPORT_SALE_S = urlApi + 'api/v1/mamlabs/Sale';
export const REPORT_SALE_UPDATE = urlApi + 'api/v1/mamlabs/sale/update';
export const DELETE_SALE = urlApi + 'api/v1/mamlabs/Sale/delete';
export const LIST_SUGGESTION = urlApi + 'api/v1/info/ImprovementSuggestion';
export const LIST_BUGS = urlApi + 'api/v1/info/ProblemReport';
export const MASTER_REPORT = urlApi + 'api/v1/mamlabs/MasterReport';
export const REMOVE_FROM_CHURN = urlApi + 'api/v1/mamlabs/removeFromChurn';
export const GET_CHURN_REPORT_COMPLETE = urlApi + 'api/v1/mamlabs/get-churn-report';
export const SEND_TAB_NOTIFICATION = urlApi + 'api/v1/company/NotifyMarqTab';
export const GET_ALL_FUP = urlApi + 'api/v1/mamlabs/getAutomaticFups';
export const GET_FUP = urlApi + 'api/v1/mamlabs/getAutomaticFupById';
export const CHANGE_FUP = urlApi + 'api/v1/mamlabs/updateFup';
export const CREATE_FUP = urlApi + 'api/v1/mamlabs/createFup';
export const DESACTIVE_ACTIVE = urlApi + 'api/v1/mamlabs/desactiveActiveCompany';
export const CHANGE_USER_FROM_COMPANY = urlApi + 'api/v1/mamlabs/update-company';
export const WORK_SHIFT_BY_TYPE = urlApi + 'api/v1/mamlabs/getworkshiftbytypeandcompany';
export const POINT_REPORT = urlApi + 'api/v1/mamlabs/getAppCompanyPointReport';
export const POINT_REPORT_DETAIL = urlApi + 'api/v1/mamlabs/getAppCompanyPointReportDetail';
export const PAYMENT = urlApi + 'api/v2/subscription/admin/payment';
export const ASSIGN_HISTORY = urlApi + 'api/v2/subscription/admin/payment-history';
export const CHANGE_ASSIGN_HISTORY = urlApi + 'api/v2/subscription/admin/subscription';
export const LIST_CHURNS = urlApi + 'api/v2/company/ChurnResume';
export const ADMIN = urlApi + 'api/v1/mamlabs/getAppAdmins';
export const USERS = urlApi + 'api/v1/mamlabs/getAppUsers';
export const GET_USER_AUTH = urlApi + 'v1/support/auths';
export const USERS_DEVICES = urlApi + 'api/v1/mamlabs/GetUserDevices';
export const USERS_LASTS_ACCESS = urlApi + 'api/v1/mamlabs/GetLastAccess';
export const USERS_DISABLED = urlApi + 'api/v1/mamlabs/getdismissedemployee';
export const USERS_ENABLE = urlApi + 'api/v1/mamlabs/reactivateusersbyidlist';
export const GET_SELECT_BOX = urlApi + "api/v1/info/geBalanceTimelineToSelectBox"
export const GET_BALANCE = urlApi + "api/v1/mamlabs/balance-timeline";
export const USER_PERFIL = urlApi + 'api/v1/mamlabs/getAppUserProfile';
export const RESET_PASS = urlApi + 'api/v1/mamlabs/ResetUserPassword';
export const FORGOT_PASS = urlApi + 'api/v1/mamlabs/ForceEmailForgotPassword';
export const CODE_SUB = urlApi + 'api/v1/mamlabs/getAppCodeSubscriptions';
export const CREATE_CODE = urlApi + 'api/v1/mamlabs/CreateCodeSubscription';
export const PAYMENTS = urlApi + 'api/v1/subscription/admin/payments';
export const PAYMENT_PENDING = urlApi + 'api/v1/subscription/admin/payments/pending-expired';

// Healthcheck de pagamentos / NF (dashboard no Master)
export const PAYMENT_HEALTH_DASH = urlApi + 'api/v1/subscription/master/healthcheck/dashboard';
export const PAYMENT_HEALTH_NO_NF = urlApi + 'api/v1/subscription/master/healthcheck/boletos-without-nf';
export const PAYMENT_HEALTH_NF_ERRORS = urlApi + 'api/v1/subscription/master/healthcheck/nf-errors';
export const PAYMENT_HEALTH_BOLETOS = urlApi + 'api/v1/subscription/master/healthcheck/boletos';
export const PAYMENT_HEALTH_TRIGGER_IUGU = urlApi + 'api/v1/subscription/master/healthcheck/trigger/iugu-pending';
export const PAYMENT_HEALTH_TRIGGER_ASAAS = urlApi + 'api/v1/subscription/master/healthcheck/trigger/asaas';
export const PAYMENT_HEALTH_TRIGGER_INVOICES = urlApi + 'api/v1/subscription/master/healthcheck/trigger/generate-invoices';
export const PAYMENT_HEALTH_TRIGGER_SNAPSHOT = urlApi + 'api/v1/subscription/master/healthcheck/trigger/snapshot';
export const PAYMENT_HEALTH_NF_CONSULT = urlApi + 'api/v1/subscription/master/healthcheck/nf/consult';
export const PAYMENT_HEALTH_NF_REPROCESS = urlApi + 'api/v1/subscription/master/healthcheck/nf/reprocess';
export const CANCEL_INVOICE = urlApi + 'api/v1/subscription/admin/payment/cancel/';
export const DELETE_PAYMENT = urlApi + 'api/v1/subscription/admin/payment/delete/';
export const PAYMENT_HISTORY = urlApi + 'api/v1/subscription/admin/payment/';
export const SIGNATURE = urlApi + 'api/v1/subscription/admin/';
export const CHECK_PAYMENT = urlApi + 'api/v1/mamlabs/validatebankslips';
export const COMPANY_PAYMENT_INFO = urlApi + 'api/v1/payment/mam/GetPaymentInfo';
export const USER_ROLE_MASTER = urlApi + 'api/v1/user/SwapUsersRoleMaster';
export const SEND_EMAIL_SUB = urlApi + 'api/v1/subscription/send-email/';
export const SWITCH_INVOICE = urlApi + 'api/v1/subscription/switch-invoice/';
export const UPDATE_EXPIRATION = urlApi + 'api/v1/mamlabs/updateCompanyExpiration';
export const CHANGE_BLOCK = urlApi + 'api/v1/mamlabs/marqboard-block/';
export const CLIENT_SET_ONBOARDING = urlApi + 'api/v1/mamlabs/set-onboarding?companyId=';
export const ADD_COMPANY_NOTES = urlApi + 'api/v1/mamlabs/updateCompanyNotes';
export const CHANGE_FINANCIAL_EMAIL = urlApi + 'api/v1/mamlabs/updateFinancialEmail';
export const CHANGE_COMPANY_FINANCIAL_EMAIL = urlApi + 'api/v1/mamlabs/financialEmail';
export const UPDATE_COMPANY_TOTAL = urlApi + 'api/v1/mamlabs/updateCompanyTotalPlanEmployee';
export const CHANGE_WS_CICLIC = urlApi + 'api/v1/mamlabs/updateworkshiftciclic';
export const CHANGE_WS_DAY = urlApi + 'api/v1/mamlabs/updateworkshiftday';
export const GET_WS_DAY = urlApi + 'api/v1/mamlabs/getworkshifdays';
export const GET_WS = urlApi + 'api/v1/mamlabs/getworkshifs';
export const CREATE_CONTENT_BLOG = urlApi + 'api/v1/blog/mamlabs/create';
export const EDIT_CONTENT_BLOG = urlApi + 'api/v1/blog/mamlabs/update';
export const LIST_CONTENT_BLOG = urlApi + 'api/v1/blog/items';
export const DELETE_CONTENT_BLOG = urlApi + 'api/v1/blog/mamlabs/delete';
export const CONTENT_BLOG = urlApi + 'api/v1/blog/item/';
export const UPLOAD_IMG_BLOG = urlApi + 'api/v1/blog/uploadImage';
export const CATEGORIES = urlApi + 'api/v1/blog/categories';
export const ADMIN_INFO_DETAIL = urlApi + 'api/v1/mamlabs/GetAppAdminInfosDetail';
export const UPDATE_COMPANY_PAID = urlApi + 'api/v1/mamlabs/updateCompanyPlan';
export const UPDATE_COMPANY_FREE = urlApi + 'api/v1/mamlabs/updateCompanyPlan';
export const GET_SOLICITATION = urlApi + 'api/v1/mamlabs/getSolicitationsDetail';
export const UPLOAD_IMG_BLOG_PROD = 'https://api.marqponto.com.br/api/v1/blog/uploadImage';
export const UPLOAD_INFO_PROD = urlApi + 'api/v1/info/ticket/upload';
export const CREATE_POINT_DAY = urlApi + 'api/v1/mamlabs/create-pointdays';
export const CREATE_24_WORKED_DAYS = urlApi + 'v1/support/createScheduleDays';
export const REACTIVE_USER = urlApi + 'api/v1/mamlabs/reactivateusersbyidlist';
export const USER_LOGOUT = urlApi + 'api/v1/user/UpdateUserForceLogout';
export const UPDATE_WS_D = urlApi + 'api/v1/mamlabs/updwsextraphaseandremuntype';
export const UPDATE_WS_D_MASS = urlApi + 'api/v1/mamlabs/updateWorkShiftsInMass';
export const UPDATE_WS_R = urlApi + 'api/v1/mamlabs/updateworkshiftretroactive';
export const JOB_CREATE_UPD = urlApi + 'api/v1/master/JobCreateUpd';
export const GET_NOTIFICATIONS = urlApi + 'api/v1/mamlabs/getAdvices';
export const CREATE_NOTIFICATIONS = urlApi + 'api/v1/mamlabs/createAdvice';
export const COMPANY_HOW_HOT = urlApi + 'api/v1/mamlabs/GetCompanyHowHotIs?c=';
export const NEED_PHOTO_MARQTAB = urlApi + "api/v1/mamlabs/SetNeedPhotoToMarqTab";
export const NEED_LOCATION_MARQTAB = urlApi + "api/v1/mamlabs/SetNeedLocationToMarqTab";
export const DELETE_TRIAL_USAGE = urlApi + "api/v1/mamlabs/delete-trial-usage";
export const SET_CALENDAR_ENABLED = urlApi + "api/v1/mamlabs/SetIsCalendarEnabled";
export const SET_BACKOFFICEV2 = urlApi + "v1/support/UpdateUsingV2";
export const SET_PIN_COMPANY = urlApi + "api/v1/mamlabs/setPinCompany";
export const SET_CHAT_ENABLED = urlApi + "api/v1/mamlabs/SetIsChatEnabled";
export const CHANGE_ID_IUGU = urlApi + "api/v1/subscription/update-iugu";
export const UPDATE_ASAAS = urlApi + "api/v1/subscription/update-asaas";
export const GET_CANCEL_DETAILS = urlApi + "v1/internal/Cancelations"
export const GET_CANCEL_DETAILS_V2 = urlApi + "v2/internal/Cancelations"
export const CANCELATION_CONTACT_DONE = urlApi + "api/v1/company/cancelationContactDone/"
export const CHANGE_DATA_BUSINESS_UNITS = urlApi + "v1/internal/BusinessUnitDocument"
export const DELETE_USER_DAYS = urlApi + "v1/internal/DeleteUserDays"
export const DETAILS_DAYS_USER = urlApi + "v1/internal/UserDetailedDays"
export const UPDATE_COMPANY_LOCALE = urlApi + "api/v1/Company/CompanyLocal";

export const SET_REFUND_ENABLED = urlApi + "api/v1/mamlabs/SetIsRefundEnabled";
export const SET_ONBOARDING_ENABLED = urlApi + "api/v1/mamlabs/SetIsOnboardingEnabled";
export const SET_JOB_ENABLED = urlApi + "api/v1/mamlabs/SetIsSetIsOpportunityPortalEnabled";
export const SET_DP_ENABLED = urlApi + "api/v1/mamlabs/SetIsDpMenuEnabled";
export const SET_CHECKIN_ENABLED = urlApi + "api/v1/mamlabs/SetIsCheckinEnabled";
export const SET_PAUSE = urlApi + "api/v1/mamlabs/SetIsPauseEnabled";

export const GET_LIST_CSAT = urlApi + "api/v1/csat";
export const POST_REPORT_CSAT = urlApi + "api/v1/csat/relatorio";
export const DELETE_CSAT = urlApi + "api/v1/csat/";
export const GET_LINK_CSAT = urlApi + "api/v1/csat/generateLink";
export const SEND_EMAIL_CSAT = urlApi + "api/v1/csat/sendEmailToClient";

export const GET_LINK_NPS = urlApi + 'api/v1/companyNPS';
export const SEND_EMAIL_NPS = urlApi + 'api/v1/companyNPS/email/';
export const GET_LAST_NPS = urlApi + 'api/pipe/GetPipelineBusiness'
export const CHANGE_NPS = urlApi + "api/v1/mamlabs/companyNps/contactDone";
export const COMPANY_NPS = urlApi + 'api/v1/mamlabs/companyNps';
export const REPORT_NPS = urlApi + 'api/v1/mamlabs/npsReport';

export const GET_POINT_LOG_REPORT_BY_ID = urlApi + "api/v1/info/GetPointLogReportById?id=";
export const GET_INVOICES_LOG_REPORT_BY_ID = urlApi + "api/v1/mamlabs/GetLogsIntegrationExternal";

export const DELETE_CODE = urlApi + "api/v1/mamlabs/delete-code-subscription/";
export const PAYMENT_HISTORIES_M = urlApi + "api/v1/subscription/master/histories";
export const PUT_EDIT_INVOICES = urlApi + "api/v1/subscription/UpdatePaymentInvoice";
export const UPLOAD_INVOICE_MASTER = urlApi + "api/v1/info/invoice/master/upload";
export const UPLOAD_PAYMENT_MASTER = urlApi + "api/v1/info/payment/master/upload";
export const PAYMENT_HISTORIES_M_DETAIL = urlApi + "api/v1/subscription/master/history-detailed?id=";
export const PAYMENT_HISTORIES_M_DUPLICATE = urlApi + "api/v1/subscription/master/history-duplicate";
export const PAYMENT_HISTORIES_S = urlApi + "api/v1/subscription/master/subscriptions";
export const PAYMENT_HISTORIES_S_DETAIL_CANCEL = urlApi + "api/v1/subscription/admin/payment/cancel/";
export const GET_MASTER_DASH = urlApi + "api/v1/subscription/master/dash?p=pppp";
export const GET_SUB_BY_COMPANY = urlApi + "api/v1/subscription/GetSubscriptionByCompanyId/";

export const UPDATE_PLAN_NAME = urlApi + "api/v1/payment/updatePlanMaster";

export const FEATURES_ALL = urlApi + "api/v1/info/features";
export const FEATURE_ALL = urlApi + "api/v1/info/feature";
export const GET_FEATURES = urlApi + "api/v1/feature/master";

export const CANCEL_INVOICE2 = urlApi + "api/v1/subscription/cancel-invoice/";
export const UPDATE_PAYMENT_HISTORY_STATUS = urlApi + "api/v1/subscription/payment-history/update-status";
export const SYNC_PAYMENT_STATUS = urlApi + "api/v1/subscription/payment-history/sync-status";
export const GENERATE_INVOICE = urlApi + "api/v1/subscription/generate-invoice/";
export const FEATURE_PLAN = urlApi + "api/v1/feature/plan/";
export const GET_INVOICE = urlApi + "api/v1/subscription/get-invoice/";
export const UPDATE_INVOICES = urlApi + "api/v1/subscription/update-notes";
export const GET_LIST_RENEW = urlApi + "api/v1/subscription/master/renews";
export const GET_LIST_UPSELL = urlApi + "api/v1/subscription/master/upsells";
export const GET_SUB_PLANS2 = urlApi + "api/v1/subscription/plans";
export const SUBSCRIPTION_PAYMENT2 = urlApi + "api/v2/subscription/admin/payment";
export const GET_LIST_HISTORY = urlApi + "api/v2/company/employee/log/history";

// ===== Melhorias do Master (HE3, fuso, regras de saldo, recálculo, importação) =====
// M5 - Recalcular pontos automaticamente (empresa + override por turno)
export const APPLY_RECALC_POINTS = urlApi + "api/v2/company/applyRecalcPoints";
// M1 - HE3: leitura agregada e aplicação em massa
export const GET_WORKSHIFT_FULL_VIEW = urlApi + "api/v2/company/workshiftFullView";
export const APPLY_HE3_BULK = urlApi + "api/v2/company/applyHE3Bulk";
export const GET_COMPANY_NUANCES = urlApi + "api/v2/company/nuances";
// M2 - Regras de horas extras (fases / applyToBalance)
export const APPLY_PHASE_RULES_BULK = urlApi + "api/v2/company/applyPhaseRulesBulk";
// Configurações avançadas do turno (não compensatório, notificações, tolerância) em massa
export const APPLY_WORKSHIFT_ADVANCED_BULK = urlApi + "api/v2/company/applyWorkshiftAdvancedBulk";
// Retorna as fases atuais de um turno (template pra preencher o form)
export const GET_WORKSHIFT_PHASES = urlApi + "api/v2/company/workshift"; // + "/{id}/phases"
// Regras de fases NO NÍVEL DA EMPRESA (CompanySettings)
export const COMPANY_SETTINGS_PHASES = urlApi + "api/v2/company/CompanySettingsPhases"; // + "?companyId="
export const UPDATE_COMPANY_SETTINGS_PHASES = urlApi + "api/v2/company/updateCompanySettingsPhases";
// M3 - Fuso por turno (em massa). O unitário já existe (WORKSHIFT_TIMEZONE_UPDATE).
export const UPDATE_WORKSHIFT_TIMEZONE_BULK = urlApi + "api/v1/workshift/WorkshiftTimezone/bulk";
// M4 - Importação CSV de saldos (UserHourBalanceDay)
export const BALANCE_IMPORT_TEMPLATE = urlApi + "api/v2/balance/import/template";
export const BALANCE_IMPORT_UPLOAD = urlApi + "api/v2/balance/import";
export const BALANCE_IMPORT_HISTORY = urlApi + "api/v2/balance/import/history";

// M8 - Filtro de empresas por features ativas
export const FEATURES_AVAILABLE = urlApi + "api/v1/info/features";
export const COMPANY_IDS_BY_FEATURES = urlApi + "api/v1/info/features/companyIds";

// M6 - Sistema dinâmico de tags por empresa
export const COMPANY_TAGS = urlApi + "api/v2/companyTags";
export const COMPANY_TAGS_BY_COMPANY = urlApi + "api/v2/companyTags/byCompany";
export const COMPANY_TAGS_ASSIGN = urlApi + "api/v2/companyTags/assign";
export const COMPANY_TAGS_UNASSIGN = urlApi + "api/v2/companyTags/unassign";
export const COMPANY_TAGS_COMPANY_IDS = urlApi + "api/v2/companyTags/companyIdsByTags";
export const COMPANY_TAGS_BY_COMPANIES = urlApi + "api/v2/companyTags/byCompanies";
export const COMPANY_TAGS_BULK = urlApi + "api/v2/companyTags/bulk"; // add/remove em massa (limite 200)

// M7 - Excedentes (rotina mensal de cobrança extra de funcionários)
export const EXCEDENTES_GENERATE_INITIAL = urlApi + "api/v2/excedentes/generate";
export const EXCEDENTES_UPLOAD_AND_GENERATE_BOLETOS = urlApi + "api/v2/excedentes/process";
export const EXCEDENTES_DOWNLOAD_FINAL = urlApi + "api/v2/excedentes/final";
export const EXCEDENTES_HISTORY = urlApi + "api/v2/excedentes/history";

// Migração IUGU -> ASAAS (tela de migração de clientes mensais)
export const MIGRACAO_ASAAS_LIST = urlApi + "api/v2/migracao-asaas/lista";
export const MIGRACAO_ASAAS_PREVIEW = urlApi + "api/v2/migracao-asaas/preview";
export const MIGRACAO_ASAAS_EXECUTE = urlApi + "api/v2/migracao-asaas/execute";
export const MIGRACAO_ASAAS_VINCULAR = urlApi + "api/v2/migracao-asaas/vincular";
export const MIGRACAO_ASAAS_SUSPENDER_IUGU = urlApi + "api/v2/migracao-asaas/suspender-iugu";
export const MIGRACAO_ASAAS_ALTERAR = urlApi + "api/v2/migracao-asaas/alterar-assinatura";
export const MIGRACAO_ASAAS_ROLLBACK = urlApi + "api/v2/migracao-asaas/rollback";
export const MIGRACAO_ASAAS_UPLOAD = urlApi + "api/v2/migracao-asaas/upload";
export const MIGRACAO_ASAAS_HISTORICO = urlApi + "api/v2/migracao-asaas/historico";
export const GET_LIST_PLAN = urlApi + "api/v1/subscription/payment/company/history";
export const GET_LIST_FEATURES = urlApi + "api/v1/mamlabs/GetCompanyFeatures";
export const CHANGE_GIVEGAIN = urlApi + "api/v3/mamlabs/updateCompanyPlan";
export const CREAT_RENOVATION = urlApi + "api/v2/subscription/admin/payment/renew";
export const UPDATE_BUSINESS_UNIT = urlApi + "api/v1/subscription/UpdateBussisnessUnit";
export const GET_CHURN_CATEGORY = urlApi + "v1/internal/ChurnCategory";
export const CHANGE_JOURNEY_ONBOARDING = urlApi + "api/v1/mamlabs/company-journey";
export const DORES_SELECT_BOX = urlApi + "v1/internal/doresSelectBox";
export const OBJETIVOS_SELECT_BOX = urlApi + "v1/internal/objetivosSelectBox";
export const FEATURES_COURTESY_SELECT_BOX = urlApi + "v1/internal/featuresSelectBox";
export const IMPORT_COLLABORATORS = urlApi + "api/v1/mamlabs/import-employees";
export const IMPORT_COLLABORATORS_PT = urlApi + "api/v1/mamlabs/import-employees-pt";
export const IMPORT_COLLABORATORS_PT_EXAMPLE = urlApi + "api/v1/mamlabs/import-employees-pt-example";
export const IMPORT_COLLABORATORS_EXAMPLE = urlApi + "api/v1/mamlabs/exemple-file-import-employees";
export const UPDATE_SUBSCRIPTION_ANTECIPATION = urlApi + "api/v1/subscription/antecipation";
export const UPDATE_SUBSCRIPTION_INACTIVE = urlApi + "api/v1/subscription/inactive";
export const SYNC_SUBSCRIPTION = urlApi + "api/v1/subscription/sync-invoices-iugu/";
export const SYNC_SUBSCRIPTION_ASAAS = urlApi + "api/v1/subscription/sync-invoices-asaas/";
export const SALE_OBJECTIVES = urlApi + "v1/internal/sale";
export const GET_ALL_CUSTOM_MIRRORS = urlApi + "v1/support/getCustomMirrorsByCompanyId/";
export const UPDATE_CUSTOM_MIRROR = urlApi + "v1/support/updateCustomMirror";
export const FORCE_SUBSCRIPTION_GAIN = urlApi + "subscription/internal/force-close-deal";

//SupportTools
export const CREATE_ACCOUNTANT = urlApi + "api/v1/user/createAccountantWithCompanies";
export const CREATE_MARQTAB = urlApi + "api/v1/user/MarQTabAccess";
export const IMPORT_DATA_BENEFITS_OF_EMPLOYEES = urlApi + "v1/support/importEmployeesOnlyBenefits";
export const IMPORT_EXAMPLE_DATA_BENEFITS_OF_EMPLOYEES = urlApi + "v1/support/exampleFileToImportBenefitsDataOfEmployees";
export const UPDATE_WORKSHIFT_TIMEZONE = urlApi + "api/v1/workshift/WorkshiftTimezone";
export const WORKSHIFT_TIMEZONE_UPDATE = urlApi + "api/v1/workshift/UpdateWorkshiftTimezone";
export const GET_TIMEZONE_LIST = urlApi + "api/v1/company/GetTimeZoneList";
export const SWITCH_WORKSHIFT_TO_SCHEDULE = urlApi + "api/v1/workshift/WorkshiftToSchedule";
export const ENQUEUE_WORK_SCHEDULE = urlApi + "v1/schedule/enqueueAgain";
export const DUAL_ACCESS = urlApi + "api/v1/user/RegisterEmployeeToNewCompany";
export const CHECK_DUPLICATED_DAYS = urlApi + "v1/support/checkDuplicatedDays";
export const ENABLE_WITHDRAW = urlApi4 + "v1/company/IncludeToWithdraw";
export const SUSPENDED_STATUS_TO_FAULT = urlApi + "v1/support/handle-day";
export const CHANGE_ACCOUNTANT_ACCESS = urlApi + "v1/support/switchToAccountant";
export const CONFIGURE_OVERTIME = urlApi + "api/v1/CompanyOvertimeSettings";
export const UPDATE_BILLING_TARGET = urlApi + "v1/support/billing";

// Integration Management (MarQ.Integration.API) — cadastro de integrações e api_tokens
export const INTEGRATION_MANAGEMENT = urlApiIntegration + "management/integration";

// SALES
export const SALES_INFORMATION = urlApi + "api/v1/subscription/sale";
export const SALES_REPORT_ERROR = urlApi + "api/v1/subscription/sale/report-error";
export const CONTEXT_COMPANY = urlApi + "api/v1/company/contentSetting/";
export const CONTEXT_USER = urlApi + "api/v1/user/contentSetting/";

// NOTAS FISCAIS (emissão manual interna)
export const COMPANY_TO_REGISTER_INFOS = urlApi + "api/v1/company/ToRegisterInfos";
export const INVOICE_CREATE = urlApi + "api/v1/invoice/create";
export const INVOICE_LOGS = urlApi + "api/v1/invoice/logs";
export const INVOICE_BY_REFERENCE = urlApi + "api/v1/invoice/by-reference";
export const INVOICE_CANCEL = urlApi + "api/v1/invoice/cancel";

// MARQ IA
export const GET_AI_CREDITS = urilApiV2 + "v2/document/credits/";
export const ADD_AI_CREDITS = urilApiV2 + "v2/document/credits";

//MOCK
export const CREATE_MOCK_DATA = urilApiV2 + 'v1/mocks';

// BENEFITS
export const ENABLE_BENEFITS = urlApi4 + "v1/TransactionInternal/enable-benefits";
export const ENABLE_PIX_OUT = urlApi4 + "v1/Master/enable-pix-out";
export const PMA_EXTRACT_BENEFITS = urlApi4 + "v1/Master/pma-extract";
export const CONFIRM_PAYMENT_BENEFITS = urlApi4 + "v1/TransactionInternal/confirm-funds-in";

export const DASH_BENEFITS = urlApi4 + "v1/master/dashboard";
export const CARDS_BENEFITS = urlApi4 + "v1/master/card-orders";
export const CARD_DETAILS = urlApi4 + "v1/Master/card-order";
export const COMPANY_SUMMARY = urlApi4 + "v1/Master/card-summary";
export const CHANGE_STATUS_SUMMARY = urlApi4 + "v1/cardorder/updateCardOrderByMaster";
export const GET_CARD_ORDER = urlApi4 + "dockcardorder/card-order";
export const GET_EMBOSSING_FILES = urlApi4 + "dockcardorder/card-order/embossing-file";
export const CREATE_CARD_ORDER = urlApi4 + "dockcardorder/card-order/request";
export const ACCESS_PAYMENT_PIX = urlApi4 + "v1/master/access/password";
export const VALIDATE_PIX_KEY = urlApi4 + "dockPix/key";
export const CONFIRM_PIX_ORDER = urlApi4 + "dockPix/pix-out/transfer";

export const ORDERS_DAYS = urlApi4 + "v1/master/component/orders"
export const KYCS_DAYS = urlApi4 + "v1/master/component/kycs"
export const CARDS_DAYS = urlApi4 + "v1/master/component/cards"


export const ORDERS_BENEFITS = urlApi4 + "v1/Master/orders";
export const KYCS_BENEFITS = urlApi4 + "v1/Master/kycs";


// ===== Adicionais FB (vão junto com o bloco de Melhorias do Master mais acima) =====

// FB9c - Edição em massa de flags da empresa (com senha)
export const BULK_UPDATE_COMPANY_FLAGS = urlApi + "api/v1/support/companies/bulkUpdateFlags";

// FB8b - Rotinas automáticas de tags de sistema
export const SYSTEM_TAGS_RUN_ROUTINES = urlApi + "api/v1/support/tags/run-routines";
export const SYSTEM_TAGS_RUN_ROUTINE = urlApi + "api/v1/support/tags/run-routine"; // append /{systemCode}

// FB8c - Histórico de mudanças de tags
export const COMPANY_TAGS_HISTORY = urlApi + "api/v2/companyTags/history";

export const FACE_LAB_POINTS = urlApi + "api/v1/facelab/master/points";
export const FACE_LAB_ENROLL = urlApi + "api/v1/facelab/master/enroll";
export const FACE_LAB_IDENTIFY = urlApi + "api/v1/facelab/master/identify";
export const FACE_LAB_HEALTH = urlApi + "api/v1/facelab/master/health";
export const FACE_LAB_POC_TELEMETRY = urlApi + "api/v1/facelab/master/poc/telemetry";
export const FACE_LAB_POC_RUN = urlApi + "api/v1/facelab/master/poc/run";


// EXTERNAL REQUESTS

export const CEP_GLOBAL = 'https://viacep.com.br/ws/';
//adicionar /json/ após o CEP




// WEBPACK FOOTER //
// ./src/urlConfig.js